import React from "react";
import { PanZoom } from "panzoom";

interface IMapViewContext {
  panZoom: PanZoom | null;
  setPanZoom: (panZoom: PanZoom) => void;
}

export const MAP_VIEW_CONTEXT = React.createContext<IMapViewContext>({
  panZoom: null,
  setPanZoom: () => {},
});

export const useMapView = (): IMapViewContext =>
  React.useContext(MAP_VIEW_CONTEXT);

const MapViewContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [panZoom, setPanZoom] = React.useState<PanZoom | null>(null);

  return (
    <MAP_VIEW_CONTEXT.Provider
      // eslint-disable-next-line react/jsx-no-constructed-context-values
      value={{
        panZoom,
        setPanZoom,
      }}
    >
      {children}
    </MAP_VIEW_CONTEXT.Provider>
  );
};

export default MapViewContextProvider;
